export class UpdateVersionHardwareRequirementRequest {
    
    //FKs
    VersionHardwareRequirementID: number; //Which requirement are we updating?
    HardwareCheckID: number; //Which hardware check (RAM, CPU, etc)
    
    //Values
    MinimumValue : number;
    OptimalValue : number;
    RecommendedValue : number;
    MinimumValueLabel : string;
    OptimalValueLabel : string;
    RecommendedValueLabel : string;
    ScoreWeighting : number;
}
